import { 
  AuthReducer,
  InterfaceReducer,
  HistoryReducer, 
  EventReducer, 
  EnumReducer,
  ResourceEnumReducer,
  RoleReducer, 
  ModuleReducer, 
  PermissionReducer, 
  ResourceUserReducer,
  AllowedReducer,
  OidcClientReducer,
  MaintenanceEventReducer,
  RsrcReducer,
  RuleReducer,
  UsersReducer,
  ClientIdReducer
} from '@leverege/api-redux'
import { SelectReducer, SelectionReducer, UIReducer } from '@leverege/ui-redux'
import { connectRouter } from 'connected-react-router'

import ApiAccessReducer from './ApiAccessReducer'
import project from './ProjectReducer'
import projects from './ProjectsReducer'
import geotile from './GeotileReducer'
import geotiles from './GeotilesReducer'
import systems from './SystemsReducer'
import devices from './DevicesReducer'
import deviceBlueprint from './DeviceBlueprintReducer'
import blueprint from './BlueprintReducer'
import resource from './ResourceReducer'
import breadcrumbs from './BreadcrumbReducer'
import scenario from './ScenarioReducer'
import contacts from './ContactsReducer'
import scenarios from './ScenariosReducer'
import scenarioSave from './ScenarioSaveReducer'
import AttributeTree from './AttributeTree'
import networks from './NetworksReducer'
import blueprints from './BlueprintsReducer'
import projectAccounts from './ProjectAccountsReducer'
import systemUsers from './SystemUsersReducer'
import timers from './TimersReducer'
import scripts from './ScriptsReducer'
import scriptLogs from './ScriptLogsReducer'
import templates from './TemplatesReducer'
import users from './UsersReducer'
import messageRoutes from './MessageRoutesReducer'

const ResourceUser = ResourceUserReducer.createSelectors( 'resourceUsers' )
const Allowed = AllowedReducer.createSelectors( 'allowed' )

export default function createReducers( { history } ) {
  return {
    auth : AuthReducer,
    project,
    projects,
    projectAccounts,
    systems,
    devices,
    contacts,
    systemUsers,
    scenario,
    scenarios,
    scenarioSave,
    blueprint,
    resource,
    deviceBlueprint,
    breadcrumbs,
    networks,
    blueprints,
    timers,
    scripts,
    scriptLogs,
    users,
    messageRoutes,
    templates,
    geotiles,
    geotile,
    // TODO : is this the best name we got
    models : InterfaceReducer,
    imagineHistory : HistoryReducer,
    events : EventReducer,
    roles : RoleReducer,
    modules : ModuleReducer,
    permissions : PermissionReducer,
    resourceUsers : ResourceUserReducer,
    allowed : AllowedReducer,
    oidc : OidcClientReducer,
    enums : EnumReducer,
    resourceEnums : ResourceEnumReducer,
    select : SelectReducer,
    selection : SelectionReducer,
    ui : UIReducer,
    maintenanceEvents : MaintenanceEventReducer,
    rsrcs : RsrcReducer,
    rules : RuleReducer,
    router : connectRouter( history ),
    apiReduxUsers : UsersReducer,
    apiAccess : ApiAccessReducer,
    clientIds : ClientIdReducer
  } 
}
export {
  AttributeTree,
  ResourceUser,
  Allowed
}
